function Header() {
    return (
        <div className="Header">
            <div className="logoContainer">
                <h1 className="headerText">jfCode.</h1>
                <div className="textCursor"></div>
                <h4 className="headerSubtext">a personal coding blog</h4>
            </div>
        </div>
    );
}

export default Header;
